import { useLocation, useNavigate, useParams } from "react-router";
import { useTranslation } from "react-i18next";

import { Stack } from "capitalrx-components-2.0/lib/layout";
import { queryString } from "capitalrx-utilities";

import { PharmacyJourneyLayout } from "@/basic/layouts/PharmacyJourneyLayout";
import { JourneySteps, FormularyButtonContainer, PharmacyListContainer, Heading, MapBounds } from "@/basic/components";
import { FormularyParams } from "@/basic/components/FormularyButtonContainer";

export const PharmacyJourneyList = () => {
  const { t: translate } = useTranslation();
  const { formulary }: FormularyParams = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const getCurrentQueryStrings = queryString.convertQueryStringToJson(location.search);

  const handleRedoSearch = (coordinates: MapBounds) => {
    const params = {
      lat: coordinates.center.latitude,
      lng: coordinates.center.longitude,
    };

    const newParams = queryString.convertJsonToQueryString({ ...getCurrentQueryStrings, ...params });

    navigate({
      pathname: `/${formulary}/pharmacy/list`,
      search: newParams,
    });
  };

  const handleItemClick = (providerId: string) => {
    const params = {
      provider_id: providerId,
    };
    const newParams = queryString.convertJsonToQueryString({ ...getCurrentQueryStrings, ...params });

    navigate({
      pathname: `/${formulary}/pharmacy/details`,
      search: newParams,
    });
  };

  const panelTitle = <Heading>{translate("PHARMACY_JOURNEY_LIST.findLocalPharmacy")}</Heading>;

  return (
    <PharmacyJourneyLayout>
      <Stack>
        <JourneySteps />
        <PharmacyListContainer
          handleItemClick={handleItemClick}
          handleRedoSearch={handleRedoSearch}
          client="capitalrx"
          coverageType={formulary.toString()}
          zipCodeFormPushTo={`/${formulary}/pharmacy/list`}
          panelTitle={panelTitle}
        />
        <FormularyButtonContainer />
      </Stack>
    </PharmacyJourneyLayout>
  );
};
